module.exports = "<p>error works!</p>\n"